import { render } from "./OtpModal.vue?vue&type=template&id=41f4f4eb"
import script from "./OtpModal.vue?vue&type=script&lang=js"
export * from "./OtpModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/retail.interapptive.media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__